module.exports = __webpack_public_path__ + "img/Logistiktrupp.72b2ee26.svg";